import { IconPrefix } from '@fortawesome/fontawesome-svg-core'

const faIconStyle: IconPrefix = 'fad'

export default { faIconStyle }
